import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { commonMessages } from 'src/utils/messages';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { CustomerFormSchemaValues } from 'src/features/customers/utils/formSchema';
import { billingMessages } from 'src/features/billing/utils/messages';
import { customersMessages } from 'src/features/customers/utils/messages';
import { LANGUAGE, PAYMENT_PROVIDER } from 'src/features/customers/utils/types';
import { LANGUAGE_TRANSLATION_MAP, PAYMENT_PROVIDER_TRANSLATION_MAP } from 'src/features/customers/utils/constants';
import { CURRENCY } from 'src/types';
import { CURRENCY_MAP } from 'src/features/moneyAccounts/utils/constants';

type CustomerFormProps = {
    form: UseFormReturn<CustomerFormSchemaValues>;
    onSubmit: (values: CustomerFormSchemaValues) => void;
};

function CustomerForm({ onSubmit, form }: CustomerFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(commonMessages.name)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="uic"
                label={formatMessage(billingMessages.legalNumber)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="external_customer_id"
                type="number"
                required={false}
                label={formatMessage(customersMessages.externalCustomerId)}
            />
            {/*<InputFormField<CustomerFormSchemaValues>*/}
            {/*    form={form}*/}
            {/*    name="stripe_customer_id"*/}
            {/*    type='number'*/}
            {/*    required={false}*/}
            {/*    label={formatMessage(customersMessages.stripeCustomerId)}*/}
            {/*/>*/}
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="address"
                required={false}
                label={formatMessage(commonMessages.address)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="city"
                required={false}
                label={formatMessage(commonMessages.city)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="country"
                required={false}
                label={formatMessage(commonMessages.country)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="email"
                type="email"
                required={false}
                label={formatMessage(commonMessages.email)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="phone"
                type="tel"
                required={false}
                label={formatMessage(commonMessages.phone)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="tax_registration_number"
                required={false}
                label={formatMessage(billingMessages.taxNumber)}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="representative"
                required={false}
                label={formatMessage(billingMessages.legalRepresentative)}
            />
            <SelectFormField<CustomerFormSchemaValues>
                form={form}
                name="language"
                required={false}
                label={formatMessage(commonMessages.language)}
                options={Object.values(LANGUAGE)}
                optionTranslationMap={LANGUAGE_TRANSLATION_MAP}
            />
            <SelectFormField<CustomerFormSchemaValues>
                form={form}
                name="configuration.payment_provider"
                required={false}
                label={formatMessage(customersMessages.paymentProviderType)}
                options={Object.values(PAYMENT_PROVIDER)}
                optionTranslationMap={PAYMENT_PROVIDER_TRANSLATION_MAP}
            />
            <SelectFormField<CustomerFormSchemaValues>
                form={form}
                name="configuration.currency"
                required={false}
                label={formatMessage(commonMessages.currency)}
                options={Object.values(CURRENCY)}
                optionTranslationMap={CURRENCY_MAP}
            />
            <InputFormField<CustomerFormSchemaValues>
                form={form}
                name="configuration.invoice_grace_period_days"
                type="number"
                required={false}
                label={formatMessage(customersMessages.invoiceGracePeriodDays)}
            />
        </Form>
    );
}

export default CustomerForm;
